export default __webpack_public_path__ + "static/media/dialogflow.d1d4d36d.png";